import {CohortSegment} from 'common/query-builder/query-block/segment-menu/types';

export enum LiftType {
  Time = `timeComparison`,
  Overall = `percentOverall`,
  Segment = `segment`,
}

export const TIME_COMPARE_NON_LIFT_KEY = `time`;

// Currently the same as the display name, but those may change and we want tracking to stay static
export const LiftTypeTrackingName: {[key in LiftType | typeof TIME_COMPARE_NON_LIFT_KEY]: string} = {
  [TIME_COMPARE_NON_LIFT_KEY]: `time`,
  [LiftType.Time]: `timeLift`,
  [LiftType.Overall]: `overall`,
  [LiftType.Segment]: `segment`,
};

export const LIFT_TRACKING_PREFIX = `report info: lift comparison type`;

export const LiftTypeDisplayName: {[key in LiftType]: string} = {
  [LiftType.Time]: `Time`,
  [LiftType.Overall]: `Overall`,
  [LiftType.Segment]: `Segment`,
};

/*
 * Long-form name of a Lift Type.
 * Used in tooltips, e.g. "Pie chart is not available with overall comparison"
 */
export const LiftTypeDescription: {[key in LiftType]: string} = {
  [LiftType.Time]: `percent change over time`,
  [LiftType.Overall]: `overall comparison`,
  [LiftType.Segment]: `segment comparison`,
};

export const LIFT_TOOLTIP_COMPARE = `compared to`;

/*
 * Represents an option to display when showing "Segment" comparison.
 * Can be a cohort or a property value.
 */
export interface SegmentLiftBaselineOption {
  displayName: string;
  cohortSegment?: CohortSegment;
  propertyValue?: string;
}

export interface LiftTypeEnabledState {
  enabled: boolean;
  reason?: string;
}

export interface LiftTypeOverrides {
  [LiftType.Segment]?: LiftTypeEnabledState;
  [LiftType.Overall]?: LiftTypeEnabledState;
  [LiftType.Time]?: LiftTypeEnabledState;
}
